import type { PluralOverrides, StringOverrides } from '../index';

/**
 * Flemish is Belgian Dutch. Written Flemish is almost identical to Netherlands Dutch, so
 * only the genuinely different wording is listed here and the rest is inherited.
 *
 * "u" is the usual address in Belgian interfaces where the Netherlands would use "je",
 * and Flemish prefers "toepassing"-style native words over English loans.
 */
export const strings: StringOverrides = {
  'gate.copy': 'Uw wallet wordt op dit toestel versleuteld voordat er iets wordt gesynchroniseerd.',
  'gate.create': 'Nieuwe wallet maken',
  'gate.open': 'Mijn bestaande wallet openen',
  'empty.addFirst': 'Voeg uw eerste item toe.',
  'empty.noResults': 'Geen enkel opgeslagen item komt overeen met die zoekopdracht.',

  'editor.addTitle': 'Voeg een titel toe.',
  'editor.tapAddFront': 'Tik om de voorkant toe te voegen',
  'editor.tapAddBack': 'Tik om de achterkant toe te voegen',
  'editor.photoNote': 'Foto’s tot {mb} MB worden versleuteld en op dit toestel opgeslagen, en daarna automatisch gesynchroniseerd als synchronisatie aanstaat.',
  'editor.attachmentNote': 'Bestanden worden precies zo versleuteld als ze zijn gekozen en op dit toestel opgeslagen. Safe Wallet blokkeert veelvoorkomende uitvoerbare bestanden, scripts, actieve webinhoud en bestanden met macro’s, maar scant bestanden niet op malware.',
  'editor.photoNotOnDevice': 'De versleutelde foto staat niet op dit toestel.',
  'attach.notOnDevice': 'De versleutelde bijlage staat nog niet op dit toestel.',
  'attach.photoNotOnDevice': 'De versleutelde foto staat nog niet op dit toestel.',
  'attach.notStored': 'Niet op dit toestel opgeslagen',
  'attach.previewUnavailable': 'Voor dit bestandstype is geen voorbeeld beschikbaar. Download het en open het met een app die u vertrouwt.',
  'field.pin': 'Pincode',
};

export const plurals: PluralOverrides = {};
